import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class WriteReviewService {

  constructor(public http: HttpClient, public utils: UtilsService) { }

  submitReview(data: any, isReviewSubmitted: any) {
    let url: string = ''
    isReviewSubmitted ? url = `${this.utils.apiUrl}CustomerConsultation/UpdateProductReview` : url = `${this.utils.apiUrl}CustomerConsultation/SaveProductReview`
    return this.http.post(url, data)
      .pipe(catchError(this.utils.processError.bind(this)))
  }
}
